import React from 'react';
export function Footer() {
  return <footer className="bg-pilates-dark text-white/70 py-10 px-4 text-center text-sm" data-id="element-96">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-97">
        <p data-id="element-98">
          © {new Date().getFullYear()} Kit Pilates Listo — Todos los derechos
          reservados.
        </p>
        <p className="text-xs text-white/55 max-w-2xl mx-auto leading-relaxed" data-id="element-99">
          El contenido de esta página tiene fines informativos y educativos. No
          reemplaza una formación profesional certificada. Consulta a un
          profesional de la salud antes de comenzar cualquier actividad física.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-white/60" data-id="element-100">
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-101">
            Términos y Condiciones
          </a>
          <span data-id="element-102">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-103">
            Política de Privacidad
          </a>
          <span data-id="element-104">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-105">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}